import { createAsyncThunk } from '@reduxjs/toolkit';

import ApplicationProcessApi from 'api/curo/ApplicationProcessApi';
import { ApplicationProcessActionTypes } from 'enums/curo/ApplicationProcessActionTypes';

export const createRunSnowflakeRefiReloanThunk = (api: ApplicationProcessApi) =>
  createAsyncThunk(
    ApplicationProcessActionTypes.RunSnowflakeRefiReloanCheck,
    async () => {
      const response = await api.runSnowflakeRefiReloanCheck();

      return response;
    },
  );
